import CriteriaVM from './criteria-vm';
import ConfigurationVM from './configuration-vm';
export default function (data, parent) {
  var self = this;
  var r = Kadenze.Util.objFromString;
  var $container = $('#js-cw-step3');

  self.parent = parent;

  self.id = ko.observable(r(data, 'id', ''));
  self.dom_id = ko.observable('cf-' + (self.id() || 'new-' + _.random(100)));
  self.coursework_id = ko.computed(function() {
    return r(data, 'coursework_id', parent.coursework() ? parent.coursework().id() : null);
  });
  self.name = ko.observable(r(data, 'name', null)).extend({required: true });
  self.field_definition = ko.observableArray();
  self.grading_criteria = ko.observableArray();
  self.grading_configurations = ko.observableArray();
  self.gallery = ko.observable(r(data, 'gallery', false));
  self.computed_gallery = ko.computed({
    read: function() {
      return self.gallery();
    },
    write: function(value) {
      if (value || parent.canRemoveGalleryField()) {
        self.gallery(value);
      } else {
        new Kadenze.Notice.error($.extend({}, self.defaultNoticeOptions, { message: 'You have selected to accept participation from this gallery, please select a different coursework gallery before turning this off.' }));
        self.computed_gallery.notifySubscribers();
      }
    }
  });
  self.peer_review = ko.observable(r(data, 'peer_review', false));
  self.required = ko.observable(r(data, 'required', true));
  self.required_for_review = ko.computed(function() {
    return self.required();
  }).extend({ equal: { params: true, onlyIf: self.peer_review, message: 'This field has to be required since it\'s needed for peer assessment.' } });
  self.autograde = ko.observable(r(data, 'autograde', false));
  self.auto_grader_id = ko.observable(r(data, 'auto_grader_id', null));
  self.selected_auto_grader_id = ko.computed({
    read: function() {
      return self.auto_grader_id();
    },
    write: function(value) {
      if (self.grading_criteria().length > 0) {
        Kadenze.UIUtil.confirmAction('Selecting a new grader type will reset all the existing criteria definitions. Are you sure you want to continue?', function() {
          self.auto_grader_id(value);
        }, function() {
          self.selected_auto_grader_id.notifySubscribers();
        });
      } else {
        self.auto_grader_id(value);
      }
    }
  });
  self.auto_grader_details = ko.observable();
  self.auto_grader_versions = ko.observableArray([]);
  self.auto_grader_version = ko.observable();
  self.auto_grader_jsonapi_version = ko.observable();
  self.auto_grader_entry_point = ko.observable(r(data, 'auto_grader_entry_point', null));
  self.critspec_loading = ko.observable(false);
  self.editing = ko.observable(r(data, 'editing', false));
  self.plagiarism_detection = ko.observable(r(data, 'plagiarism_detection', false));
  self.check_library_plagiarism = ko.observable(r(data, 'check_library_plagiarism', false));
  self.student_plagiarism_visibility = ko.observable(r(data, 'student_plagiarism_visibility', false));
  self._destroy = ko.observable(r(data, '_destroy', false));
  self._type = ko.observable(r(data, '_type', (data.field_definition && data.field_definition.length > 0) ? data.field_definition[0]['_type'] : 'FileField'));
  self.plagiarism_file_types = ko.observableArray([]);

  self.validExtForPlagiarismDetection = function(self){
    if (self.plagiarism_file_types().length === 0) {
      return true; // not fetched yet
    }

    if (self.plagiarism_detection()){
      var isValid = true;
      _.each(self.file_types(), function(type) {
        if (type !== '' && !_.includes(self.plagiarism_file_types(), type)){
          isValid = false;
        }
      });
      return isValid;
    }
    return true;
  };

  self.plagiarism_detection.extend({
    validation: {
      validator: self.validExtForPlagiarismDetection.bind(this, self),
      message: 'Selected field types are not valid for plagiarism detection',
      decorateInputElement: false,
      insertMessages: false,
      decorateElement: false
    }
  });

  self.loadGraderConfiguration = function() {
    if (!self.auto_grader_version() || !self.auto_grader_id()) {
      return;
    }

    parent.loadGraderInfoForField(self);
  };

  self.auto_grader_id.subscribe(function(newVal) {
    if (newVal) {
      self.set_grader_versions(newVal);
      // self.loadGraderConfiguration();
    }
  });

  self.auto_grader_version.subscribe(function(newVal) {
    if (newVal) {
      self.loadGraderConfiguration();
    }
  });

  self.available_criteria = ko.computed(function() {
    var criteria = (self.auto_grader_details() && self.auto_grader_details().criteria) || (self.parent.criteria_cache()[self.auto_grader_id()] && self.parent.criteria_cache()[self.auto_grader_id()].criteria);
    if (self.auto_grader_id() && self.auto_grader_version() && !criteria) {
      self.loadGraderConfiguration();
    }
    return criteria || [];
  });

  self.available_configurations = ko.computed(function() {
    var graderId = self.auto_grader_id();
    var graderDetails = self.auto_grader_details() || parent.criteria_cache()[graderId];
    if (!graderDetails) {
      parent.loadGraderInfoForField(self);
    }
    return graderDetails && graderDetails.configuration || [];
  });

  self.getConfigurationDetails = function(config_id) {
    var graderDetails = self.auto_grader_details() || parent.criteria_cache()[self.auto_grader_id()];
    if (!graderDetails) {
      console.warn('No autograder details found for ' + ag_id + '. Attempting to load them.');
      parent.loadGraderInfoForField(self);
      return;
    }
    var config = _.find(graderDetails.configuration, function(config) {
      return config.config_id === config_id;
    });
    return config;
  };

  self.isValidFileExts = function(exts) {
    return _.every(exts, function(ext) {
      return (/^[.]\w+$/i).test(ext);
    });
  };

  self.addFieldDefinition = function(fd) {
    var base_fd = {
      _type: ko.observable(r(fd, '_type', self._type()))
    };

    switch (self._type()) {
    case 'FileField':
      var dependencies = r(fd, 'runnable_options.dependencies', [{url: ''}]);
      var ko_dependencies = [];
      if (dependencies.length > 0) {
        for(var i = 0; i < dependencies.length; i++) {
          ko_dependencies.push({url: ko.observable(dependencies[i].url).extend({ url: true })});
        }
      }
      self.original_min_files_required = r(fd, 'min_files_required', 1);
      self.original_max_files_allowed = r(fd, 'max_files_allowed', 1);
      self.field_definition.push($.extend({}, base_fd, {
        file_types: ko.observable(r(fd, 'file_types', '')),
        runnable_options: {
          entry_point: ko.observable(r(fd, 'runnable_options.entry_point', '')),
          entry_source: ko.observable(r(fd, 'runnable_options.entry_source', '')),
          convert_jupyter: ko.observable(r(fd, 'runnable_options.convert_jupyter', '')),
          dependencies: ko.observableArray(ko_dependencies)
        },
        min_files_required: ko.observable(r(fd, 'min_files_required', 1)),
        max_files_allowed: ko.observable(r(fd, 'max_files_allowed', 1))
      }));
      break;
    case 'UrlField':
      self.field_definition.push($.extend({}, base_fd, {
        name: ko.observable(r(fd, 'name', ''))
      }));
      break;
    }
  };

  if(data.field_definition && data.field_definition.length > 0) {
    $.each(data.field_definition, function(index, field_definition) {
      self.addFieldDefinition(field_definition);
    });
  } else {
    self.addFieldDefinition();
  }

  if(data.grading_configurations && data.grading_configurations.length > 0) {
    $.each(data.grading_configurations, function(index, configuration) {
      self.grading_configurations.push(new ConfigurationVM(_.extend(configuration, {editing: false, _destroy: false}), parent, self));
    });
  }

  if(data.grading_criteria && data.grading_criteria.length > 0) {
    $.each(data.grading_criteria, function(index, criterion) {
      self.grading_criteria.push(new CriteriaVM(_.extend(criterion, {editing: false, _destroy: false}), parent, self));
    });
  }

  self.getFileExtsForType = function (type) {
    let exts = [];
    if (_.isEmpty(type)) {
      exts = _.keys(self.file_meta());
    } else {
      exts = _.keys(_.pick(self.file_meta(), function (value, key, object) {
        return value.type === type;
      }));
    }
    return exts;
  };

  self.file_meta = ko.observable({});
  self.selected_file_type = ko.observable();
  self.selected_file_type.subscribe(function (type) {
    let $row = $('#' + self.dom_id());
    let $input = $row.find('.js-tags-input').first();
    $input.tagsinput('removeAll');
    if (!_.isEmpty(type)) {
      _.each(self.getFileExtsForType(type), function (ext) {
        $input.tagsinput('add', ext);
      });
    }
  });
  self.available_file_types = ko.computed(function () {
    let types = [];
    if (!_.isEmpty(self.file_meta())) {
      types = _.uniq(_.map(self.file_meta(), function(ext) { return ext.type; }));
    }
    return types;
  });
  self.available_file_exts = ko.computed(function () {
    let type = self.selected_file_type();
    return self.getFileExtsForType(type);
  });
  self.file_types = ko.computed({
    read: function() {
      var types = [];
      if (self._type() == 'FileField' && self.field_definition() && self.field_definition().length > 0) {
        types = self.field_definition()[0].file_types().split(',');
      }
      return types;
    },
    write: function(value) {
      if (self._type() == 'FileField' && self.field_definition() && self.field_definition().length > 0) {
        self.field_definition()[0].file_types(value);
      }
    }
  }).extend({validation: {validator: self.isValidFileExts, message: 'Please enter valid file extensions' }});

  self.min_files_required = ko.computed({
    read: function () {
      var min = 1;
      if (self._type() == 'FileField' && self.field_definition() && self.field_definition().length > 0) {
        min = self.field_definition()[0].min_files_required();
      }
      return min;
    },
    write: function (value) {
      if (self._type() == 'FileField' && self.field_definition() && self.field_definition().length > 0) {
        var val = parseInt(value);
        if (parent.coursework().submissions_begun() && val > self.original_min_files_required) {
          new Kadenze.Notice.error($.extend({}, self.defaultNoticeOptions, { message: 'Sorry, min files required cannot be increased as submissions have already begun.' }));
          self.min_files_required.notifySubscribers();
        } else {
          self.field_definition()[0].min_files_required(val);
        }
      }
    }
  });

  self.max_files_allowed = ko.computed({
    read: function () {
      var min = 1;
      if (self._type() == 'FileField' && self.field_definition() && self.field_definition().length > 0) {
        min = self.field_definition()[0].max_files_allowed();
      }
      return min;
    },
    write: function (value) {
      if (self._type() == 'FileField' && self.field_definition() && self.field_definition().length > 0) {
        var val = parseInt(value);
        if (parent.coursework().submissions_begun() && val < self.original_max_files_allowed) {
          new Kadenze.Notice.error($.extend({}, self.defaultNoticeOptions, { message: 'Sorry, max files allowed cannot be reduced as submissions have already begun.' }));
          self.max_files_allowed.notifySubscribers();
        } else {
          self.field_definition()[0].max_files_allowed(val);
        }
      }
    }
  });

  self.min_files_required.extend({ min: 1, max: self.max_files_allowed });
  self.max_files_allowed.extend({ min: self.min_files_required });

  self.accepts_zip = ko.computed(function() {
    return self.file_types().indexOf('.zip') > -1;
  });

  self.accepts_js = ko.computed(function() {
    return self.file_types().indexOf('.js') > -1;
  });

  self.accepts_jupyter = ko.computed(function() {
    return self.file_types().indexOf('.ipynb') > -1;
  });

  self.runnable_options = ko.computed(function() {
    var options = {};
    if (self._type() == 'FileField' && self.field_definition() && self.field_definition().length > 0) {
      options = self.field_definition()[0].runnable_options || {};
    }
    return options;
  });

  self.set_grader_versions = function(graderStr) {
    // Find the grader
    var graderObj = _.find(parent.autograders(), function(item) {
      return item.name() === graderStr;
    });

    if (graderObj) {
      self.auto_grader_versions(graderObj.versions());
      self.auto_grader_version(self.auto_grader_version() || graderObj.versions()[0]);
    }
  };

  self.getAutoGraderCriterion = function(ag_id, feature_id) {
    // var grader = self.getAutoGraderById(ag_id);
    var graderDetails = self.auto_grader_details() || parent.criteria_cache()[ag_id];
    var criterion = ko.utils.arrayFilter(graderDetails.criteria, function(crit) {
      return crit.feature_id === feature_id;
    });
    return criterion;
  };


  self.addDependency = function(item, event) {
    item.dependencies.push({url: ko.observable('').extend({ url: true })});
  };

  self.deleteDependency = function(item, event) {
    ko.utils.arrayForEach(self.field_definition(), function(fd) {
      fd.runnable_options.dependencies.remove(function(collection) {
        return collection === item;
      });
    });
  };



  self.getFileTypes = function() {
    $.getJSON(Kadenze.Routes.coursework_file_types_path({meta: true}))
      .pipe(function (exts, status, jqXHR) {
        self.file_meta(exts);
        var plagiarism_file_types = _.chain(exts)
          .keys()
          .filter(function(key) {
            return exts[key].plagiarism_detectable;
          })
          .value();
        self.plagiarism_file_types(plagiarism_file_types);
      });
  };

  self.fileTypeSource = function(query, cb) {
    var filteredList = $.grep(self.available_file_exts(), function (item, index) {
      return item.match(query);
    });

    var mapped = $.map(filteredList, function (item) { return { value: item }; });
    cb(mapped);
  };

  self.initTypeAheadInputs = function($parent) {
    if (self.available_file_exts().length === 0) {
      self.getFileTypes();
    }

    $parent.find('.js-tags-input').each(function(_idx, _ele) {
      var $_ele = $(_ele);
      if ($_ele.parent().find('.bootstrap-tagsinput').length === 0) {
        var tagsinput = $_ele.tagsinput({
          confirmKeys: [9, 13, 188]
        });
        $_ele.tagsinput('input').blur(function() {
          $_ele.tagsinput('add', $(this).val());
          $(this).val('');
        });
      }
      if ($('.bootstrap-tagsinput .twitter-typeahead', $_ele.parent()).length === 0) {
        $('.bootstrap-tagsinput input', $_ele.parent()).typeahead({
          minLength: 0,
          hint: false,
          highlight: false
        }, {
          name: 'noname',
          displayKey: 'value',
          source: self.fileTypeSource
        }).bind('typeahead:selected', $.proxy(function (obj, datum) {
          $_ele.tagsinput('add', datum.value);
        }));

        $('.bootstrap-tagsinput input', $_ele.parent()).bind('typeahead:opened', function () {
          var ev = $.Event('keydown');
          ev.keyCode = ev.which = 40;
          $(this).trigger(ev);
          $(this).typeahead('val', '');
          return true;
        });
      }
    });
  };

  self.toggleOptions = function(options, item, push) {
    if (push) {
      options.push(item);
    } else if (options.indexOf(item) > -1) {
      options.splice(options.indexOf(item), 1);
    }
  };

  self.options = ko.computed(function() {
    var options = [];
    self.toggleOptions(options, 'Required', self.required());
    self.toggleOptions(options, 'Public', self.gallery());
    self.toggleOptions(options, 'Peer Assessment', self.peer_review());
    self.toggleOptions(options, 'Auto Grade', self.autograde());
    return options.join(', ');
  });

  self.submissionsBegunWarning = _.once(function () {
    if (parent.coursework().submissions_begun()) {
      new Kadenze.Notice.attention($.extend({}, parent.defaultNoticeOptions, { message: 'Submissions for this coursework have begun. Please use caution before modifying requirements as it may have unintended consequences.' }));
    }
    return true;
  });

  self.keysToWatch = ['name', 'file_types', 'required', 'gallery', 'peer_review', 'min_files_required', 'max_files_allowed'];
  self.snapshot = {};

  self.takeSnapshot = function() {
    _.each(self.keysToWatch, function(key) { self.snapshot[key] = _.isObject(self[key]()) ? self[key]().toString() : self[key](); });
  };

  self.restoreSnapshot = function() {
    _.each(self.keysToWatch, function(key) {
      if (_.has(self.snapshot, key))
        self[key](self.snapshot[key]);
    });
  };

  self.resetSnapshot = function() {
    self.snapshot = {};
  };

  self.validate = function() {
    var propsToValidate = [];
    _.each(Object.getOwnPropertyNames(self), function(key) {
      if (ko.isObservable(self[key])) {
        propsToValidate.push(self[key]);
      }
    });
    var errors = ko.validation.group(propsToValidate);
    errors.showAllMessages(true);
    return errors();
  };

  self.isValid = function () {
    return self.validate().length == 0;
  };

  self.initEditorUI = function() {
    var $row = $('#' + self.dom_id());
    self.initTypeAheadInputs($row);
    Kadenze.UIUtil.initExpandableTextareas();
  };

  self.toggleEditor = function() {
    if (!self.editing()) {
      self.takeSnapshot();
      self.initEditorUI();
    }
    var $row = $('#' + self.dom_id());
    var $editRow = $('.display-table__edit_row', $row).first();
    $row.toggleClass('collapsed');
    $row.toggleClass('expanded');
    $editRow.collapse('toggle');
    self.editing(!self.editing());
  };

  self.destroy = function(item, event) {
    if (parent.coursework().submissions_begun()) {
      new Kadenze.Notice.error(
        $.extend(
          {},
          parent.defaultNoticeOptions,
          {
            message: 'Fields for this coursework cannot be deleted as submissions have already begun.'
          }
        )
      );
    } else if (self.gallery() && !parent.canRemoveGalleryField()) {
      new Kadenze.Notice.error(
        $.extend(
          {},
          self.defaultNoticeOptions,
          {
            message: 'You have selected to accept participation from this gallery, please select a different coursework gallery before deleting this field.'
          }
        )
      );
    } else {
      Kadenze.UIUtil.confirmAction('Are you sure you want to delete this field?', function() {
        self._destroy(true);
        parent.save($container);
      });
    }
    event.stopPropagation();
  };

  self.add = function(item, event) {
    if (item.isValid()) {
      parent.coursework().coursework_fields.push(item);
      var response = parent.save($container);
      response.success(function() {
        parent.newField(false);
      });
      response.error(function (xhr, textStatus, errorThrown) {
        parent.coursework().coursework_fields.pop();
        new Kadenze.Notice.error($.extend({}, parent.defaultNoticeOptions, { message: xhr.responseJSON.errors }));
      });
    }
  };

  self.update = function(item, event) {
    if (self.isValid()) {
      var response = parent.save($container);
      response.success(function() {
        self.resetSnapshot();
      });
      response.error(function (xhr, textStatus, errorThrown) {
        new Kadenze.Notice.error($.extend({}, parent.defaultNoticeOptions, { message: xhr.responseJSON.errors }));
      });
    }
  };

  self.cancel = function(item, event) {
    if (parent.newField()) {
      parent.newField(false);
    } else {
      self.restoreSnapshot();
      self.toggleEditor();
    }
  };

  self.auto_grader_version(data.auto_grader_version);

  if (self.auto_grader_id()) {
    self.set_grader_versions(self.auto_grader_id());
  }

  return self;
}

